export default __webpack_public_path__ + "static/media/Custom1.8b044287.png";